module.exports = __webpack_public_path__ + "img/done.61e9719f.svg";